import { render, staticRenderFns } from "./risingStars.vue?vue&type=template&id=46588700&scoped=true"
import script from "./risingStars.vue?vue&type=script&lang=js"
export * from "./risingStars.vue?vue&type=script&lang=js"
import style0 from "./risingStars.vue?vue&type=style&index=0&id=46588700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46588700",
  null
  
)

export default component.exports